import { TranslateService } from '@ngx-translate/core';
import { IReport, IResponseStatus } from '../services/report-workflow-exam.service';
import { SignResultStatus } from '@se/models';

export const isResponseSignOk = (result: IResponseStatus) => result.responseStatusType === SignResultStatus.Ok;

export const isResponseSignErrored = (result: IResponseStatus) => result.responseStatusType !== SignResultStatus.Ok;

export const isResponseSignLocked = (result: IResponseStatus) =>
    [SignResultStatus.Locked, SignResultStatus.Unlocked].includes(result.responseStatusType);

export const isResponseServerError = (result: IResponseStatus) =>
    [SignResultStatus.Failed, SignResultStatus.PdfGenerationFailed, SignResultStatus.P7mGenerationFailed].includes(
        result.responseStatusType,
    ) && !isResponseSignificantImagesError(result);

export const isResponseSignificantImagesError = (result: IResponseStatus) =>
    result.responseStatusType === SignResultStatus.PdfGenerationFailed &&
    result.error.significantImagesOnPacs !== undefined &&
    result.error.maxSignificantImagesToAdd !== undefined &&
    result.error.significantImagesOnPacs > result.error.maxSignificantImagesToAdd;

export const isExceptionCredentialFault = (result: IResponseStatus): boolean =>
    result.error?.message === 'Exception_CredentialsFault';

export const createSignificantImagesErrorMessage = (
    responses: IResponseStatus<IReport>[],
    reports: IReport[],
    t: TranslateService,
): string => {
    const maxImages = responses[0]?.error.maxSignificantImagesToAdd ?? 0;
    let message = t.instant('significantImagesErrorHeader', {
        p0: maxImages,
    });
    message +=
        '\r\n' +
        responses
            .map((res) => {
                const report = reports.find((r) => r.id == res.id);
                const info = report?.reportDetailForNotification ?? res.id;
                const images = res.error.significantImagesOnPacs ?? 0;
                return t.instant('significantImagesErrorDetail', { p0: info, p1: images });
            })
            .join('\r\n');
    message += '\r\n' + t.instant('significantImagesErrorFooter');
    return message;
};
